import React, { HTMLProps } from "react";
import { Field, FieldProps } from "formik";
import ControlLayout from "./ControlLayout/ControlLayout";
import FieldPhone from "../fields/FieldPhone/FieldPhone";


interface IProps extends HTMLProps<HTMLInputElement> {
  isError?: boolean;
  label?: string;
  mask?: string;
  maskChar?: string;
  alwaysShowMask?: boolean;
  formatChars?: any;
  unmask?: boolean;
  rightComponent?: React.ReactNode,
  onPast?: (e: any) => void;
  role?: 'input' | 'phone';
}
// <AppFormGlobalPhone  name="login"  label={t("Номер телефону")} />
const AppFormGlobalPhone: React.FC<IProps> = (props) => {
  const {name,  label, id, disabled} = props;

  return (
    <Field name={name}>
      {(propsField: FieldProps) => {
        const {field, meta, form} = propsField;
        const isError: boolean = meta.touched && !!meta.error;

        return (
          <ControlLayout isError={isError} error={meta.error}>
            <FieldPhone
              id={id}
              label={label}
              disabled={disabled}
              name={name}
              country={'it'}
              excludeCountries={['ru']}
              // preferredCountries={['ua', 'pl', 'de']}
              // onlyCountries={['en', 'ua', 'it', 'de', ]}
              enableSearch
              // value={phone}
              // onChange={setPhone}
              inputStyle={{ width: '100%' }}
              containerStyle={{ maxWidth: 400 }}
              enableAreaCodes={true}
              disableDropdown={false}
              disableCountryCode={false}
              separateDialCode={true} // <-- показує +380 окремо
              {...field}
              onBlur={()=>{
                form.setFieldTouched(name, true);

              }}
              onChange={(value)=>{
                console.log(value);
                form.setFieldValue(name, value);
              }}
              isError={isError}
            />
          </ControlLayout>
        );
      }}
    </Field>
  );
};

export default AppFormGlobalPhone;